<h2 class="title">{{ "CHANGE_PASSWORD.TITLE" | translate }}</h2>
<div class="subtitle">{{ "CHANGE_PASSWORD.SUBTITLE" | translate }}</div>
<form [formGroup]="form" (keydown.enter)="change()">
  <div class="form-content">
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{ "CHANGE_PASSWORD.OLD_PASSWORD" | translate }}</mat-label>
      <input
        matInput
        type="password"
        placeholder="{{ 'CHANGE_PASSWORD.OLD_PASSWORD' | translate }}"
        formControlName="oldPassword"
        autofocus
      />
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{ "CHANGE_PASSWORD.NEW_PASSWORD" | translate }}</mat-label>
      <input
        matInput
        type="password"
        placeholder="{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }}"
        formControlName="newPassword"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{ "CHANGE_PASSWORD.REPEAT_NEW_PASSWORD" | translate }}</mat-label>
      <input
        matInput
        type="password"
        placeholder="{{ 'CHANGE_PASSWORD.REPEAT_NEW_PASSWORD' | translate }}"
        formControlName="repeatNewPassword"
      />
    </mat-form-field>
    <div class="password-requirements">
      @for (req of requirements; track req.label) {
        <app-requirement-check [state]="req.getState()">
          {{ req.label | translate }}
        </app-requirement-check>
      }
    </div>
  </div>
</form>
<button
  (click)="change()"
  [disabled]="form.invalid"
  mat-raised-button
  color="primary"
  type="button"
>
  {{ "CHANGE_PASSWORD.CHANGE_PASSWORD" | translate }}
</button>
